import { render, staticRenderFns } from "./share-dropdown.vue?vue&type=template&id=dd23ee2a&"
import script from "./share-dropdown.vue?vue&type=script&lang=js&"
export * from "./share-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./share-dropdown.vue?vue&type=style&index=0&id=dd23ee2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports